import { useStoryBlokStoriesByComponent } from "@provider/storyblok-provider";
import type { VacancyStoryblok } from "@type/storyblock-types";
import * as React from "react";

export interface Vacancy {
  slug: string;
  name: string;
  content: VacancyStoryblok;
}

export function useVacancies(): Vacancy[] {
  const stories = useStoryBlokStoriesByComponent<VacancyStoryblok>("vacancy_item");
  return React.useMemo(
    () =>
      stories.map((story) => ({
        slug: story.slug,
        name: story.content?.title || story.name,
        content: story.content,
      })),
    [stories]
  );
}

export function useVacancyCount() {
  return useVacancies().length;
}

export function useVacancy(slug: string | undefined) {
  const vacancies = useVacancies();
  return vacancies.find((vacancy) => vacancy.slug === slug);
}

export function vacancyMeta(vacancy: Vacancy) {
  return [vacancy.content?.hours, vacancy.content?.location].filter(Boolean).join(" · ");
}
